// @flow
import type { Row, SelectOption } from './types';

// Loan categories
export const types: Array<SelectOption> = [
  {
    value: 'personal',
    label: 'Personal: pago mensual y sistema de interés directo'
  },
  {
    value: 'commercial',
    label: 'Comercial: pago semestral y sistema de interés francés'
  }
];

// Loan term
// Monthly for personal loans (up to 36), in semesters for commercial loans (up to 6)
const personalTerms: Array<SelectOption> = [
  { value: 6, label: '6 meses' },
  { value: 12, label: '12 meses' }
];

const commercialTerms: Array<SelectOption> = [
  { value: 1, label: '1 semestre' },
  { value: 2, label: '2 semestres' }
];

export const terms = {
  personal: personalTerms,
  commercial: commercialTerms
};

// Age range for asking for a loan, in years
export const minAge: number = 18;
export const maxAge: number = 65;

// Table headings
export const headings: Row = [
  'Cuota',
  'Vencimiento',
  'Deuda',
  'Amortización',
  'Interés',
  'Gastos Adm.',
  'Seguro',
  'Valor Cuota',
  'Total Amortizado'
];

// MONTHLY Rates
// Need to be parsed into semestral rates for commercial loans
// (or loans where freq != 1, i.e.: semestral, trimestral, etc.)
export const defaultPersonalInterestRate: number = 0.07; // 7% (Directo) 
export const defaultCommercialInterestRate: number = 0.095; // 9.5% (Frances)

// Gastos administrativos y gastos por seguro
export const defaultAdminFeeRate: number = 0.01; // 1%
export const defaultInsuranceFeeRate: number = 0.001; // %0,1%
